import { ContentsLink } from '@teamsparta/stack-icons';
import Image from 'next/legacy/image';
import { DoubleQuotation } from 'public/svg/pm/payment/DoubleQuotation';
import type { RefObject } from 'react';
import React from 'react';

import type { Channel, Lecturer } from '@/api/webinar';
import Only from '@/components/common/Only';

import * as S from './WebinarLecturerSection.style';

type WebinarLecturerSectionProps = {
  refObject: RefObject<HTMLElement>;
  lecturer: Lecturer;
};
const WebinarLecturerSection = ({
  refObject,
  lecturer,
}: WebinarLecturerSectionProps) => {
  return (
    <S.Section ref={refObject}>
      <S.Title>연사</S.Title>
      <Only.Mobile>
        <S.LectureSaying>
          <DoubleQuotation />
          <p>{lecturer.saying}</p>
        </S.LectureSaying>
      </Only.Mobile>
      <S.LecturerContainer>
        <S.LectureImgWrapper>
          <Image
            src={`${process.env.NEXT_PUBLIC_CDN_BASE_URL}/${lecturer.image}`}
            layout='fill'
            alt='연사자 이미지'
            objectFit='cover'
            objectPosition='center'
          />
        </S.LectureImgWrapper>
        <S.LectureInfoContainer>
          <Only.Desktop>
            <S.LectureSaying>
              <DoubleQuotation />
              <p>{lecturer.saying}</p>
            </S.LectureSaying>
          </Only.Desktop>
          <S.LectureHistory>
            <S.LectureName>{lecturer.name}</S.LectureName>
            <S.LectureCareers>
              {lecturer.careers.map((career) => (
                <S.LectureCareer key={'강사 이력' + career}>
                  {career}
                </S.LectureCareer>
              ))}
            </S.LectureCareers>
            <S.LectureChannels>
              {lecturer.channels.map((channel) => (
                <LectureChannel key={'강사 채널' + channel} channel={channel} />
              ))}
            </S.LectureChannels>
          </S.LectureHistory>
        </S.LectureInfoContainer>
      </S.LecturerContainer>
    </S.Section>
  );
};
type LectureChannelProps = {
  channel: Channel;
};
const LectureChannel = ({ channel }: LectureChannelProps) => {
  switch (channel.source) {
    case 'GitHub':
      return (
        <S.LectureChannel
          href={channel.link}
          target='_blank'
          rel='noopener noreferrer'
        >
          <ContentsLink size={16} color='#2958ff' />
          GitHub
        </S.LectureChannel>
      );
    case 'Blog':
      return (
        <S.LectureChannel
          href={channel.link}
          target='_blank'
          rel='noopener noreferrer'
        >
          <ContentsLink size={16} color='#2958ff' />
          Blog
        </S.LectureChannel>
      );
    case 'Profile':
      return (
        <S.LectureChannel
          href={channel.link}
          target='_blank'
          rel='noopener noreferrer'
        >
          <ContentsLink size={16} color='#2958ff' />
          Profile
        </S.LectureChannel>
      );
  }
};
export default WebinarLecturerSection;
